export const getActiveTab = (tabsArray) => {
  return tabsArray.find(({ isActive }) => isActive)
}
